import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col">
      <Header />
      
      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">이용약관</h1>
          <p className="text-gray-600 mb-8">최종 수정일: 2024년 1월 1일</p>

          <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제1조 (목적)</h2>
              <p className="text-gray-700 leading-relaxed">
                본 약관은 AI Funnel(이하 "회사")이 제공하는 마케팅 퍼널 생성 및 관리 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제2조 (정의)</h2>
              <p className="text-gray-700 leading-relaxed mb-4">본 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li><strong>"서비스"</strong>란 회사가 제공하는 AI 기반 마케팅 퍼널 생성, 분석, 관리 등의 모든 서비스를 의미합니다.</li>
                <li><strong>"이용자"</strong>란 본 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
                <li><strong>"회원"</strong>이란 회사와 서비스 이용계약을 체결하고 회원 아이디(ID)를 부여받은 자를 말합니다.</li>
                <li><strong>"아이디(ID)"</strong>란 회원의 식별과 서비스 이용을 위하여 회원이 설정하고 회사가 승인한 이메일 주소를 말합니다.</li>
                <li><strong>"비밀번호"</strong>란 회원의 동일성 확인과 회원정보의 보호를 위하여 회원이 설정하고 회사가 승인한 문자와 숫자의 조합을 말합니다.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제3조 (약관의 효력 및 변경)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 본 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 필요하다고 인정되는 경우 본 약관을 변경할 수 있으며, 회사가 약관을 변경할 경우에는 적용일자 및 변경사유를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ③ 회원은 변경된 약관에 동의하지 않을 경우 회원 탈퇴를 요청할 수 있으며, 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용할 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제4조 (회원가입)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-8">
                  <li>가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
                  <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
                  <li>허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
                  <li>이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
                </ul>
                <p className="text-gray-700 leading-relaxed">
                  ③ 회원가입계약의 성립시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제5조 (서비스의 제공 및 변경)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사는 다음과 같은 서비스를 제공합니다:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-8">
                  <li>AI 기반 마케팅 퍼널 자동 생성 서비스</li>
                  <li>퍼널 분석 및 최적화 서비스</li>
                  <li>마케팅 캠페인 관리 서비스</li>
                  <li>데이터 분석 및 리포팅 서비스</li>
                  <li>기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
                </ul>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 서비스의 내용을 변경할 경우에는 변경사유 및 내용을 서비스 화면에 공지합니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제6조 (서비스의 중단)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사에 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제7조 (회원의 의무)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회원은 다음 행위를 하여서는 안 됩니다:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-8">
                  <li>신청 또는 변경 시 허위내용의 등록</li>
                  <li>타인의 정보 도용</li>
                  <li>회사가 게시한 정보의 변경</li>
                  <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                  <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                  <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                  <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
                </ul>
                <p className="text-gray-700 leading-relaxed">
                  ② 회원은 관계법령, 본 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제8조 (회원 아이디 및 비밀번호의 관리)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회원의 아이디와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ③ 제2항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제9조 (이용요금)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용 가능합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ③ 유료 서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법령에 따릅니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제10조 (저작권의 귀속 및 이용제한)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 이용자는 서비스를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ③ 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제11조 (계약해지 및 이용제한)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회원은 언제든지 서비스 이용을 원하지 않는 경우 회원 탈퇴를 통해 이용계약을 해지할 수 있습니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 회원이 다음 각 호에 해당하는 행위를 하였을 경우 사전통지 없이 이용계약을 해지하거나 또는 기간을 정하여 서비스 이용을 중지할 수 있습니다:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-8">
                  <li>타인의 서비스 아이디 및 비밀번호를 도용한 경우</li>
                  <li>서비스 운영을 고의로 방해한 경우</li>
                  <li>가입한 이름이 실명이 아닌 경우</li>
                  <li>같은 사용자가 다른 아이디로 이중 등록을 한 경우</li>
                  <li>공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우</li>
                  <li>회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행하는 경우</li>
                  <li>타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제12조 (손해배상)</h2>
              <p className="text-gray-700 leading-relaxed">
                회사는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 동 손해가 회사의 고의 또는 중대한 과실로 인한 손해를 제외하고 이에 대하여 책임을 부담하지 아니합니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제13조 (면책조항)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ③ 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제14조 (분쟁해결)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">제15조 (재판권 및 준거법)</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  ① 회사와 이용자 간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용합니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  ② 회사와 이용자간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제소합니다.
                </p>
              </div>
            </section>

            <div className="bg-teal-50 border border-teal-200 rounded-lg p-6 mt-8">
              <p className="text-gray-800 font-semibold mb-2">부칙</p>
              <p className="text-gray-700">본 약관은 2026년 1월 1일부터 시행됩니다.</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
